export default {"src":"/_next/static/media/mathsBg.453adfab.svg","height":200,"width":200,"blurWidth":0,"blurHeight":0};